import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';

import ChoosePaymentMethod from './choosePaymentMethod/ChoosePaymentMethod';
import LinkBankAccount from './linkBankAccount/LinkBankAccount';
import LinkDebitCard from './linkDebitCard/LinkDebitCard';

const mapStateToProps = ({
    addPaymentMethodModal
}: {
    addPaymentMethodModal: RootState['addPaymentMethodModal'];
}) => addPaymentMethodModal;

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const AddPaymentMethodModal = ({
    paymentMethodType
}: {
    paymentMethodType?: string;
} & PropsFromRedux) => {
    switch (paymentMethodType) {
        case 'DEBIT_CARD':
            return <LinkDebitCard />;
        case 'BANK_ACCOUNT':
            return <LinkBankAccount />;
        default:
            return <ChoosePaymentMethod />;
    }
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(AddPaymentMethodModal);
